import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Talent_Entity } from "../../entities/talent";
import { filmsApi } from "../api/filmsApi";

const talentsAdapter = createEntityAdapter<Talent_Entity>();
const initialState = talentsAdapter.getInitialState();

export const talentEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getTalents: build.query<EntityState<Talent_Entity>, void>({
      query: () => `talents`,
      transformResponse: (responseData: Talent_Entity[]) => {
        return talentsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["talents"],
    }),
    getTalent: build.query<Talent_Entity, number>({
      query: (id) => `talents/${id}`,
      providesTags: (result, error, id) => [{ type: "talents", id }],
    }),
    createTalent: build.mutation<Talent_Entity, Partial<Talent_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `talents`,
      }),
      invalidatesTags: ["talents"],
    }),
    updateTalent: build.mutation<
      void,
      { id: number; body: Partial<Talent_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `talents/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "talents", id },
        "talents",
      ],
    }),
    deleteTalent: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `talents/${id}`,
      }),
      invalidatesTags: ["talents"],
    }),
  }),
});

export const {
  useGetTalentQuery,
  useGetTalentsQuery,
  useCreateTalentMutation,
  useDeleteTalentMutation,
  useUpdateTalentMutation,
} = talentEndpoints;

export default talentEndpoints;
